import { t } from "@impero-com/common/utils/i18n";
import { assertNever } from "@impero-com/common/utils/obj";
import i18next from "i18next";
import memoizeOne from "memoize-one";

import { TwoMonths } from "api/generated/model";
import { GenericMultiCheckboxes } from "org/control/list/controls/common/genericMultiCheckboxes";

type OnChangeCallback = (key: TwoMonths, value: boolean) => void;

interface CommonProps {
    twoMonths: Record<TwoMonths, boolean[]>;
}
type EditProps = CommonProps & { onChange: OnChangeCallback };
type ReadOnlyProps = CommonProps;
type MultiTwoMonthsCheckboxesProps =
    | ({ type: "EDIT" } & EditProps)
    | ({ type: "READ_ONLY" } & ReadOnlyProps);

function MultiTwoMonthsCheckboxes(props: MultiTwoMonthsCheckboxesProps) {
    const { labels, allLabel } = prepareLabels(i18next.language);

    switch (props.type) {
        case "EDIT": {
            const { twoMonths, onChange } = props;
            return (
                <GenericMultiCheckboxes
                    type="EDIT"
                    labels={labels}
                    allLabel={allLabel}
                    values={twoMonths}
                    onChange={onChange}
                />
            );
        }
        case "READ_ONLY": {
            const { twoMonths } = props;
            return (
                <GenericMultiCheckboxes
                    type="READ_ONLY"
                    labels={labels}
                    allLabel={allLabel}
                    values={twoMonths}
                />
            );
        }
        default: {
            return assertNever(props);
        }
    }
}

// Pass language (although it's not used explicitly) to ensure memoizeOne resets the cache
// if the language changes.
const prepareLabels = memoizeOne((_language: string) => {
    return {
        labels: {
            JanuaryFebruary: t("TwoMonth_1"),
            MarchApril: t("TwoMonth_2"),
            MayJune: t("TwoMonth_3"),
            JulyAugust: t("TwoMonth_4"),
            SeptemberOctober: t("TwoMonth_5"),
            NovemberDecember: t("TwoMonth_6"),
        },
        allLabel: t("CreateControl_Recurrence_ScheduleAllTwoMonths"),
    };
});

export { MultiTwoMonthsCheckboxes, type MultiTwoMonthsCheckboxesProps };
